/**
 * Feature flag constants
 * @module lib/feature-flags/constants
 */

/** Cookie name for storing internal override flag values (e.g., from /ab route) */
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = "x-flag-internal";

/**
 * Feature flag keys
 * Add new flags here as they are created in FLAGR
 *
 * Naming convention: FLAG_FEAT_<FEATURE_NAME>
 *
 * @example
 * // Adding a new flag:
 * // 1. Create the flag in FLAGR with tag 'jobs-pga-org'
 * // 2. Add the constant here:
 * // FLAG_FEAT_MY_NEW_FEATURE: 'jobs-my-new-feature'
 * // 3. Add it to the FLAGS array in initializeFeatures.js
 */
export const flags = {
  DEFAULT_TESTING_FLAG: "pga-com-flag-for-testing",
};
